<template>
	<menu-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
		<template v-slot:activator = '{on}'>
			<v-btn v-on = 'on' slot='activator' @click = 'visibility = !visibility' small icon class = 'mx-0 px-0'>
				<v-icon :color = '$store.getters.uiAccentIcon' small>delete_outline</v-icon>
			</v-btn>
		</template>
        <template v-slot:title>{{user.name}} {{user.lastname}}</template>
        <template v-slot:content>
           <v-layout column class = 'py-3'>
            	<span>Удалить из отчета <b>{{report.report_name}}</b>?</span>
        		<span>Пользователь больше не сможет видеть этот отчет.</span>
    		</v-layout>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deleteReportPerson'>Удалить</v-btn>
        </template>
    </menu-generic>
</template>

<script>
	import MenuGeneric from '@/components/elements/menus/Generic.vue'

	export default {
		name: 'UserReportDeleteMenu',
		props: ['data', 'postAction', 'report'],
		components: {MenuGeneric},
		data() {
			return {
				visibility: false,
				user: this.data,
				indicator: false
			}
		},
		methods: {
			deleteReportPerson() {
				this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8'
		        }
			    this.$http.patch(this.$store.getters.endpoint + '/db/reports/persons', {
				        'login': this.$store.getters.userLogin, 
				        'report_id': this.report.report_id,
				        'uid': this.user.uid
				    } , {
				        headers: {...this.$store.state.restrictedHeaders,...requestHeaders
				    }
			    }).then( (r) => {
			        let response = r.body;
			        if (response.result) {
						this.indicator = false;
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'delete',
                                target: 'report_user'
                            },
                            once: false
                        })
			            this.postAction();
			            this.visibility = false;
			        } else {
			            console.log(response)
			        }
			    })
			}
		}
	}
</script>